import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * Protected Route Component for Mentor Profile
 * Restricts access to certain routes until mentor profile is approved
 */
const ProtectedRoute = ({ children, requireApproval = true }) => {
  const user = useSelector((state) => state.user);
  const mentorFromState = useSelector((state) => state.mentor);
  
  // Prefer mentorFromState over user.mentor for latest data
  const mentor = mentorFromState || user?.mentor;
  const isApproved = mentor?.profileStatus === 'approved';

  // If route requires approval and profile is not approved, redirect to profile
  if (requireApproval && !isApproved) {
    return <Navigate to="/mentor-profile/me" replace />;
  }

  return children;
};

export default ProtectedRoute;
